import axios from "~/axios";
import { default as  defaultAuthenticatedRequest} from "~/backend/authenticatedRequest";

const fetchCurrentUserConfigs = async (baseUrl, authenticatedRequest = defaultAuthenticatedRequest) => {
    return await authenticatedRequest(async () => {
        return (await axios.get(`${baseUrl}/userconfigs`)).data;
    });
};


export default fetchCurrentUserConfigs;